
import { Route, Routes } from 'react-router-dom';
import './App.css';
import LandingPage from './Component/LandingNew';

function App() {
  return (
    <div>
      <Routes>
      <Route path="/" element={<LandingPage />} />
     </Routes>
    </div>
  );
}

export default App;
